import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import dayjs from 'dayjs'
import { forwardRef } from 'react'
import {
  createEmployee,
  deleteEmployee,
  updateEmployee,
} from '../../../store/EmployeeReducer'
import { useAppDispatch, useAppSelector } from '../../../utils/hooks'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

const Form: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.employee)

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) =>
          dispatch(
            createEmployee({
              ...values,
              hireDate:
                values.hasOwnProperty('hireDate') && values.hireDate
                  ? dayjs(values.hireDate).format('YYYY/MM/DD')
                  : null,
              seniorityDate:
                values.hasOwnProperty('seniorityDate') && values.seniorityDate
                  ? dayjs(values.seniorityDate).format('YYYY/MM/DD')
                  : null,
            })
          ).then(() => {
            return true
          }),
        update: async (values) =>
          dispatch(
            updateEmployee({
              ...values,
              hireDate:
                values.hasOwnProperty('hireDate') && values.hireDate
                  ? dayjs(values.hireDate).format('YYYY/MM/DD')
                  : null,
              seniorityDate:
                values.hasOwnProperty('seniorityDate') && values.seniorityDate
                  ? dayjs(values.seniorityDate).format('YYYY/MM/DD')
                  : null,
            })
          ).then(() => {
            return true
          }),
        delete: async (values) =>
          dispatch(deleteEmployee(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

Form.displayName = 'Form'

type FormType = { Form: typeof Form }

export { Form, type FormType }
